/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {LocalBrand} from '../models/local-brand.model';
import {ConfigService} from './config.service';

@Injectable({
  providedIn: 'root'
})
export class LocalBrandService {

  constructor(private readonly configService: ConfigService,
              private readonly http: HttpClient) {
  }

  /**
   * gets all local brands from API url
   */
  getAllLocalBrands(): Observable<LocalBrand[]> {
    return this.http.get<LocalBrand[]>(`${this.configService.baseApiUrl}local-brands`)
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Handles the errors produced by the backend
   * @param errorResponse The error produced by the API to be handled by the frontend
   */
  private handleError(errorResponse: HttpErrorResponse): Observable<any> {
    let errorMessage = 'An unexpected error has occurred.';
    if (errorResponse.error && errorResponse.error.message) {
      errorMessage = errorResponse.error.message;
    }
    return throwError(errorMessage);
  }
}
